/**
 * The close cockpit's route table (design C3 §5.9, §6.2).
 *
 * Exported as `CLOSE_ROUTES` and mounted by **P9** in `web/src/router/index.ts`,
 * which this packet does not own.
 *
 * No route here declares a module entitlement, and that is deliberate: §6 gives
 * every `internal/close` route `Module: ""` because "a tenant on any plan that
 * can post a journal must be able to close a period, and a plan flag that makes
 * a company unable to close its books is a support incident, not a commercial
 * control". A `meta.module` here would reintroduce exactly that.
 */

import type { RouteRecordRaw } from 'vue-router'

import { CLOSE_PERMISSIONS } from '@/modules/close/permissions'

export const CLOSE_ROUTES: RouteRecordRaw[] = [
  {
    path: '/close/board',
    name: 'close-board',
    component: () => import('@/modules/close/BoardView.vue'),
    meta: { titleKey: 'close.routeTitles.board', permission: CLOSE_PERMISSIONS.runRead },
  },
  {
    path: '/close/readiness',
    name: 'close-readiness',
    component: () => import('@/modules/close/ReadinessView.vue'),
    meta: { titleKey: 'close.routeTitles.readiness', permission: CLOSE_PERMISSIONS.runRead },
  },
  {
    path: '/close/runs',
    name: 'close-runs',
    component: () => import('@/modules/close/RunsView.vue'),
    meta: { titleKey: 'close.routeTitles.runs', permission: CLOSE_PERMISSIONS.runRead },
  },
  {
    path: '/close/runs/:id(\\d+)',
    name: 'close-run',
    component: () => import('@/modules/close/RunCockpitView.vue'),
    meta: { titleKey: 'close.routeTitles.cockpit', permission: CLOSE_PERMISSIONS.runRead },
  },
  {
    path: '/close/calendars',
    name: 'close-calendars',
    component: () => import('@/modules/close/CalendarsView.vue'),
    meta: { titleKey: 'close.routeTitles.calendars', permission: CLOSE_PERMISSIONS.calendarRead },
  },
  {
    path: '/close/calendars/:id(\\d+)',
    name: 'close-calendar',
    component: () => import('@/modules/close/CalendarEditorView.vue'),
    meta: { titleKey: 'close.routeTitles.calendar', permission: CLOSE_PERMISSIONS.calendarRead },
  },
]
